import script from "./DocumentItemCol.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentItemCol.vue?vue&type=script&setup=true&lang=js"

import "./DocumentItemCol.vue?vue&type=style&index=0&id=46d096f8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46d096f8"]])

export default __exports__